import { useContext, useMemo, useCallback } from 'react';
import { BusinessCollectionCompType } from '../../../../../Types/ObjektVy';
import { collectionCompToObjektVy } from '../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionUtils';
import {
  LeverantorQuery_node_TEDLRLeverantor as leverantor_node,
  LeverantorQuery as leverantor,
  LeverantorQueryVariables as leverantorVariables,
  LeverantorQuery_node_TEDLRLeverantor__Associations as Associations,
} from '../../../Leverantor/ObjektVyer/Leverantor/_QueryTypes/LeverantorQuery';
import UpdateMutation from '../../../Leverantor/ObjektVyer/Leverantor/LeverantorUpdateMutation.gql';
import AddMutation from '../../../Leverantor/ObjektVyer/Leverantor/LeverantorAddMutation.gql';
import LeverantorQuery from '../../../Leverantor/ObjektVyer/Leverantor/LeverantorQuery.gql';
import {
  LeverantorUpdateMutation as IUpdateData,
  LeverantorUpdateMutationVariables as IUpdateVariables,
} from '../../../Leverantor/ObjektVyer/Leverantor/_QueryTypes/LeverantorUpdateMutation';
import {
  LeverantorAddMutation as IAddData,
  LeverantorAddMutationVariables as IAddVariables,
} from '../../../Leverantor/ObjektVyer/Leverantor/_QueryTypes/LeverantorAddMutation';
import BusinessDataForm, {
  BusinessDataFormContext,
} from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import clientAvenyModel from '../../../../../Model/clientAvenyModel';
import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjektVySida/ObjektVySida';
import { ObjektVyKort } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyKort/ObjektVyKort';
import Attribut from '../../../_Common/Components/BusinessCollectionComponents/Attribut/Attribut';
import IntegratedAssociationList from '../../../_Common/Components/BusinessCollectionComponents/IntegratedAssociationList/IntegratedAssociationList';
import ObjektVy from '../../../_Common/Components/BusinessCollectionComponents/ObjektVy/ObjektVy';
import { useMutation, useQuery } from '@apollo/client';
import { ActiveDatabaseContext } from '../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { ObjektLank } from '../../../_Common/Components/BusinessCollectionComponents/ObjektLank/ObjektLank';
import {
  AssociationList,
  IAssociationListConfig,
} from '../../../_Common/Components/BusinessCollectionComponents/AssociationList/AssociationList';
import { OrgPersLokGruppForm } from '../../../OP/ObjektVyer/OrgPersLok/OrgPersLok';
import AssocieradObjektVy from '../../../_Common/Components/BusinessCollectionComponents/AssocieradObjektVy/AssocieradObjektVy';
import { ObjektVyFaltLista } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyFaltLista/ObjektVyFaltLista';
import AttributGrupp from '../../../_Common/Components/BusinessCollectionComponents/AttributGrupp/AttributGrupp';
import {
  removeIdsFromNewAssociations,
  IFormData,
  IFieldValidations,
  IValidateFn,
} from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import UtbetalningssattQuery from '../../../Leverantor/ObjektVyer/Leverantor/UtbetalningssattQuery.gql';
import {
  UtbetalningssattQuery as UtbetalningssattQueryData,
  UtbetalningssattQueryVariables,
} from '../../../Leverantor/ObjektVyer/Leverantor/_QueryTypes/UtbetalningssattQuery';
import ObjektVyKolumner, {
  ObjektVyKolumn,
} from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyKolumner/ObjektVyKolumner';
import { leverantorFormStateActionTransformer } from '../../../Leverantor/ObjektVyer/Leverantor/Utils/leverantorUtils';
import AttributeHeader from '../../../../../Components/Attributes/AttributeHeader/AttributeHeader';
import {
  TEDLRLeverantorSTATUSEnum,
  TEDOPOrgPersLokTypEnum,
  TEDOPOrgPersLokLOKALADREnum,
  TEDOPOrgPersLokREGELEnum,
  TEDInputLRLeverantorAddValues,
} from '../../../../../globalQueryTypes';
import ObjectSubCard from '../../../_Common/Components/ObjectSubCard';
import { definedSelectedId } from '../../../../../Components/MasterDetail/MasterDetailUtils';
import { useSelectedDetailQuery } from '../../../../../Components/QueryComponents/SelectedDetailQuery/useSelectedDetailQuery';
import FieldGroupStatusIndicator from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Components/FieldGroupStatusIndicator/FieldGroupStatusIndicator';
import EDButton from '../../../../../BaseComponents/Buttons/Button/EDButton';
import shortid from 'shortid';

const leverantormodel: IClientBusinessModel =
  clientAvenyModel.LR.BusinessModels.LRLeverantor;

const fakturamodel: IClientBusinessModel =
  clientAvenyModel.LR.BusinessModels.LRLeverantorfaktura;

const validateSparrdatum: IValidateFn<leverantor_node> = ({
  currentValues,
}): IFieldValidations => {
  const validations: IFieldValidations = [];
  const regDatum = Date.parse(currentValues.REGDATUM);
  const sparrDatum = Date.parse(currentValues.SPARRAD_FROM_DATUM);
  const fsDatum = Date.parse(currentValues.FSKATT_KONTROLLERAD_DATUM);

  if (currentValues.RABATT && currentValues.RABATT < 0) {
    validations.push({
      fieldName: 'RABATT',
      message: 'Rabatt får inte vara negativ, i alla fall inte enligt KO',
      type: 'Error',
    });
  }

  if (currentValues.RABATT && currentValues.RABATT > 1.0) {
    validations.push({
      fieldName: 'RABATT',
      message: 'Tänker du betala för att bli av med eländet?!',
      type: 'Hint',
    });
  }

  if (sparrDatum && regDatum && sparrDatum < regDatum) {
    validations.push({
      fieldName: 'SPARRAD_FROM_DATUM',
      message: 'Leverantör kan inte spärras innan registreringsdatum',
      type: 'Error',
    });
  }

  if (fsDatum && regDatum && fsDatum < regDatum) {
    validations.push({
      fieldName: 'FSKATT_KONTROLLERAD_DATUM',
      message: 'F-skatt kontrollerad innan registreringsdatum?',
      type: 'Warning',
    });
  }

  currentValues._Associations?.LevBetalningssatt?.forEach((betSatt: any) => {
    if (betSatt.KONTO_NR === '123456789')
      validations.push({
        fieldName: 'KONTO_NR',
        path: ['LevBetalningssatt', betSatt.id],
        message: 'Är detta ett test?',
        type: 'Warning',
      });
    if (betSatt.NUMERISKA_FAKTURANR === 'NEJ' && betSatt.OCR === 'JA')
      validations.push({
        fieldName: 'OCR',
        path: ['LevBetalningssatt', betSatt.id],
        message: 'OCR kräver numeriska fakturanummer',
        type: 'Error',
      });
  });

  currentValues._Associations?.Attestforslag?.forEach((forslag: any) => {
    if (forslag.REFERENS === 'David')
      validations.push({
        fieldName: 'REFERENS',
        path: ['Attestforslag', forslag.id],
        message: 'Denna person är inte pålitlig',
        type: 'Error',
      });
    if (forslag.REFERENS === 'Eniac')
      validations.push({
        fieldName: 'REFERENS',
        path: ['Attestforslag', forslag.id],
        message: 'Välj en fysisk person',
        type: 'Warning',
      });
    if (forslag.REFERENS && !forslag.REFERENS.includes(' '))
      validations.push({
        fieldName: 'REFERENS',
        path: ['Attestforslag', forslag.id],
        message: 'Ange förnam och efternamn',
        type: 'Hint',
      });
  });

  return validations;
};

const TestRutin1VyComp: BusinessCollectionCompType = props => {
  const id = props.id ? props.id : '';
  const { nodeData, loading: nodeLoading } = useSelectedDetailQuery<
    leverantor,
    leverantor_node,
    leverantorVariables
  >(LeverantorQuery, props.id);

  const [mutation, { loading, error }] = useMutation<
    IUpdateData,
    IUpdateVariables
  >(UpdateMutation);

  const [addMutation, addStatus] = useMutation<IAddData, IAddVariables>(
    AddMutation
  );

  const { activeDatabase } = useContext(ActiveDatabaseContext);
  const attestforslagConfig = useMemo<IAssociationListConfig>(() => {
    return {
      defaultVisningstyp: 'tabell',
      integrated: true,
      hideToolbar: false,
      inCard: true,
      customDefaultColumns: [
        {
          attributeDef: 'ANVANDS_FOR',
        },
        {
          attributeDef: 'GILTIG_FOR',
        },
        {
          attributeDef: 'REFERENS',
        },
        {
          attributeDef: 'AKTIV',
        },
        //   { attributeDef: 'IDString', caption: 'Referens', header: true },
        //   {
        //     attributeDef: 'MottagandeEnhet.Namn',
        //     caption: 'Mottagande enhet',
        //   },
        //   {
        //     attributeDef: 'Attestgrupp.BENAMNING',
        //     caption: 'Attestgrupp',
        //   },
        //   {
        //     attributeDef: 'Attestratt.AttestNamnTitel',
        //     caption: 'Beslutsattestant',
        //   },
        //   {
        //     attributeDef: 'MottagningsAttestRatt.AttestNamnTitel',
        //     caption: 'Mottagningsattestant',
        //   },
        //   {
        //     attributeDef: 'MottagandeEnhet.Namn',
        //     caption: 'Mottagande enhet',
        //   },
      ],
    };
  }, []);

  const updateFunction = useCallback(
    (values: IFormData) => {
      const newValues = removeIdsFromNewAssociations(values);
      return mutation({
        variables: {
          db: activeDatabase || '',
          values: {
            id: definedSelectedId(id),
            _version: nodeData ? nodeData._version : 1,
            ...newValues,
          },
        },
      });
    },
    [mutation, activeDatabase, id, nodeData]
  );

  const addFunction = useCallback(
    (values: IFormData) => {
      return addMutation({
        variables: {
          db: activeDatabase || '',
          values: values as TEDInputLRLeverantorAddValues,
        },
      });
    },
    [addMutation, activeDatabase]
  );

  const { data: utbetalningssattData } = useQuery<
    UtbetalningssattQueryData,
    UtbetalningssattQueryVariables
  >(UtbetalningssattQuery, {
    variables: { databaseName: activeDatabase || '' },
    skip: !activeDatabase,
  });
  return (
    <BusinessDataForm<leverantor_node>
      isNew={props.isNew}
      data={nodeData}
      model={leverantormodel}
      updateMutation={updateFunction}
      addMutation={addFunction}
      fullScreen={props.config?.fullPage ?? false}
      mutationError={error || addStatus.error}
      mutationLoading={loading || addStatus.loading}
      formStateActionTransformer={leverantorFormStateActionTransformer(
        utbetalningssattData?.db?.SYSUtbetalningssatt_All || [],
        nodeData?.OPTyp ?? null
      )}
      newFormContext
      initialValue={{
        STATUS: TEDLRLeverantorSTATUSEnum.NORMAL,
        _Associations: {
          OrgPers_Values: {
            _typ: TEDOPOrgPersLokTypEnum.OVRIGORG,
            ORG_NAMN: 'Ny Organisation AB',
            REGEL: TEDOPOrgPersLokREGELEnum.STANDARD,
            LOKALADR: TEDOPOrgPersLokLOKALADREnum.LOKAL,
            _Associations: {
              Adress_Values: {},
            },
          },
          Leverantorskategori_Ref: null,
        },
      }}
      validateFns={[validateSparrdatum as IValidateFn]}
    >
      <ObjektVy nodeLoading={nodeLoading} editImplemented>
        <ObjektVySida
          sidNr={1}
          caption="Leverantör"
          collectionName={leverantormodel.CollectionName}
        >
          <ObjektVyKolumner>
            <ObjektVyKolumn fullPage={props.config?.fullPage ?? false}>
              <AttributGrupp readOnly>
                <AttributeHeader
                  attributeGroups={[
                    'LEVERANTORSNR',
                    'OrgPers.ORG_NAMN',
                    ['OrgPers.FORNAMN', 'OrgPers.EFTERNAMN'],
                  ]}
                />
                <Attribut<leverantor_node> name="LEVERANTORSNR" mode="edit" />
                <Attribut<leverantor_node> name="KUNDNR" />
              </AttributGrupp>
              <ObjektVyKort>
                <AssocieradObjektVy
                  association={leverantormodel.Associations.OrgPers}
                  vy={
                    <OrgPersLokGruppForm
                      autoFocus={props.isNew}
                      association={leverantormodel.Associations.OrgPers}
                    />
                  }
                />
              </ObjektVyKort>
              <ObjektVyKort caption="Betalningsinformation">
                <ObjektVyFaltLista>
                  <ObjektLank<Associations>
                    associationName="Betalningsvillkor"
                    id={
                      nodeData &&
                      nodeData._Associations &&
                      nodeData._Associations.Betalningsvillkor
                        ? nodeData._Associations.Betalningsvillkor.id
                        : null
                    }
                  />
                  <ObjektLank<Associations>
                    associationName="Valuta"
                    id={
                      nodeData &&
                      nodeData._Associations &&
                      nodeData._Associations.Valuta
                        ? nodeData._Associations.Valuta.id
                        : null
                    }
                  />
                  <Attribut<leverantor_node> name="RIKSBANKSKOD" />
                </ObjektVyFaltLista>
                <ObjectSubCard>
                  <IntegratedAssociationList<Associations>
                    title="Leverantörens betalningssätt"
                    associationName="LevBetalningssatt"
                    label={{
                      name: 'Utbetalningssatt',
                      association: true,
                      mode: 'edit',
                    }}
                    labelAttributeNames={[{ name: 'KONTO_NR', mode: 'edit' }]}
                    contentAttributeNames={[
                      { name: 'NUMERISKA_FAKTURANR' },
                      { name: 'OCR' },
                      { name: 'Bank', association: true },
                    ]}
                  />
                </ObjectSubCard>
              </ObjektVyKort>
            </ObjektVyKolumn>
            <ObjektVyKolumn fullPage={props.config?.fullPage ?? false}>
              <AttributGrupp caption="Övrigt">
                <FieldGroupStatusIndicator
                  collectionName={leverantormodel.CollectionName}
                  fields={[
                    'ANGE_KUNDNR_SOM_FAKTREF',
                    'RABATT',
                    'REGDATUM',
                    'SPARRAD_FROM_DATUM',
                    'FSKATT_KONTROLLERAD_DATUM',
                    'Leverantorskategori',
                    'Leveransvillkor',
                    'Moms',
                    'ORDINARIE_REFERENS_TYP',
                  ]}
                  fullWidth={true}
                />
                <Attribut<leverantor_node> name="ANGE_KUNDNR_SOM_FAKTREF" />
                <Attribut<leverantor_node> name="RABATT" />
                <Attribut<leverantor_node> name="REGDATUM" />
                <Attribut<leverantor_node> name="SPARRAD_FROM_DATUM" />
                <Attribut<leverantor_node> name="FSKATT_KONTROLLERAD_DATUM" />
                <ObjektLank<Associations>
                  associationName="Leverantorskategori"
                  id={
                    nodeData &&
                    nodeData._Associations &&
                    nodeData._Associations.Leverantorskategori
                      ? nodeData._Associations.Leverantorskategori.id
                      : null
                  }
                />
                <ObjektLank<Associations>
                  associationName="Leveransvillkor"
                  id={
                    nodeData &&
                    nodeData._Associations &&
                    nodeData._Associations.Leveransvillkor
                      ? nodeData._Associations.Leveransvillkor.id
                      : null
                  }
                />
                <ObjektLank<Associations>
                  associationName="Moms"
                  id={
                    nodeData &&
                    nodeData._Associations &&
                    nodeData._Associations.Moms
                      ? nodeData._Associations.Moms.id
                      : null
                  }
                />
                <Attribut<leverantor_node> name="ORDINARIE_REFERENS_TYP" />
              </AttributGrupp>

              <BusinessDataFormContext.Consumer>
                {formContext => (
                  <ObjektVyKort caption="LEVERANTÖRSFAKTURAREFERENSER">
                    {id && (
                      <AssociationList
                        associationName="Attestforslag"
                        associationPath="Attestforslag"
                        collectionName={leverantormodel.CollectionName}
                        config={attestforslagConfig}
                        ownId={definedSelectedId(id)}
                      />
                    )}
                    <EDButton
                      label={'Lägg till'}
                      onClick={() => {
                        const id = 'New_Attestforslag_' + shortid();
                        formContext?.update([
                          {
                            associationName: 'Attestforslag',
                            operation: 'Add_Values',
                            id: id,
                          },
                        ]);
                      }}
                    />
                    <span> </span>
                    <EDButton
                      label={'Rensa'}
                      onClick={() => {
                        formContext?.formState?.currentValues?._Associations?.Attestforslag?.forEach(
                          (forslag: any) => {
                            formContext?.update([
                              {
                                associationName: 'Attestforslag',
                                operation: 'Delete_Values',
                                id: forslag.id,
                              },
                            ]);
                          }
                        );
                      }}
                    />
                  </ObjektVyKort>
                )}
              </BusinessDataFormContext.Consumer>
            </ObjektVyKolumn>
          </ObjektVyKolumner>
        </ObjektVySida>
        <ObjektVySida
          disableMasonry
          sidNr={2}
          caption="Fakturor"
          columns={1}
          collectionName={fakturamodel.CollectionName}
          leftMenuPresent
        >
          {/*  FIXME: Bättre lösning? */}
          {id && (
            <AssociationList
              collectionName={leverantormodel.CollectionName}
              ownId={definedSelectedId(id)}
              associationName="Fakturor"
            />
          )}
        </ObjektVySida>
      </ObjektVy>
    </BusinessDataForm>
  );
};

export const testRutin1Vy = collectionCompToObjektVy(
  TestRutin1VyComp,
  'testRutin1Vy'
);
